// The `ai-sentiment` custom field carries the conversation sentiment shown in
// the AI summary — one of `positive` / `neutral` / `negative` / `improving` /
// `declining`, which map directly onto `SentimentState`.
export const SENTIMENT_CUSTOM_FIELD_NAME = 'ai-sentiment'
export const SENTIMENT_CUSTOM_FIELD_TYPE = 'dropdown'

// The `systemType` value for the reserved Sentiment custom field. Prefer this
// over the bare 'sentiment' string literal when detecting Sentiment fields.
export const SYSTEM_TYPE_SENTIMENT = 'sentiment'

// Canonical worse → better ordering of the `ai-sentiment` dropdown options,
// matching the immutable order core-api provisions them in.
export const SENTIMENT_STATES_ORDERED = [
  'negative',
  'declining',
  'neutral',
  'improving',
  'positive',
] as const

// Raw option label → customer-facing label. Kept here (dependency-free) so
// non-React code can use it — the Backbone workflows editor and SENTIMENT_CONFIG
// (badges/squircles) in `components/SentimentIndicator/constants.ts` both consume
// it, so labels stay in one place.
export const SENTIMENT_STATE_LABELS: Record<
  (typeof SENTIMENT_STATES_ORDERED)[number],
  string
> = {
  negative: 'Negative',
  declining: 'Declining',
  neutral: 'Neutral',
  improving: 'Improving',
  positive: 'Positive',
}
export const SENTIMENT_POLARITY_CUSTOM_FIELD_NAME = 'ai-sentiment-polarity'
export const SENTIMENT_URGENCY_CUSTOM_FIELD_NAME = 'ai-sentiment-urgency'
export const SENTIMENT_TREND_FIELD_NAME = 'ai-sentiment-trend'
